import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Database from '../../types/Database'

export interface ProfileRatingDisplayProps {
  ratingAggregates: Database.RatingAggregates
}

const ProfileRatingDisplay = ({
  ratingAggregates
}: ProfileRatingDisplayProps) => {
  const { totalRatingsReceived, averageTickScore } = ratingAggregates

  if (totalRatingsReceived === 0) {
    return (
      <Box>
        <Typography variant='body2' color='text.secondary'>
          No ratings yet
        </Typography>
      </Box>
    )
  }

  return (
    <Box>
      <Typography variant='body1' fontWeight='bold'>
        {averageTickScore.toFixed(1)}/5 ticks
      </Typography>
      <Typography variant='body2' color='text.secondary'>
        from {totalRatingsReceived} ratings
      </Typography>
    </Box>
  )
}

export default ProfileRatingDisplay
